export default __webpack_public_path__ + "images/residential-icon.png?cb7bd165a22d1cef508e9b8887de836d";